import React, { useState } from 'react'
import { Link } from 'react-router'

import NumberFormat from 'react-number-format'

import configpath from 'configpath'
import { GETPAID_STATUS, GETPAID_STATUS_LABEL } from 'reduxpath/ducks/Project/Pitch'

import SuperUserButton from '../SuperUserButton'

const host = configpath.wisp_public_url

const PitchRow = props => {
  const { pitch } = props
  const poCreator = props.poCreator.rows.filter(p => p.pitch.id === pitch.id)
  const poCreatorURL = poCreator.length && poCreator[0].url ? poCreator[0].url : '#'
  const poNumber = poCreator.length && poCreator[0].poNumber ? poCreator[0].poNumber : '-'
  const isBankInfoExist =
    pitch.profileBankInformation && pitch.profileBankInformation.length > 0
  let lineItems = []

  const [loanStatus, setLoanStatus] = useState(pitch.loan?.status)

  const [loanStatusLabel, setLoanStatusLabel] = useState(() => {
    if (!loanStatus) return '- not apply -'

    if (loanStatus === GETPAID_STATUS.IN_REVIEW && !props.isProjectStarted) {
      return 'Waiting for project kickstart'
    }

    return GETPAID_STATUS_LABEL[loanStatus]
  })

  const updateLoanStatus = newLoanStatus => {
    setLoanStatus(newLoanStatus)
    setLoanStatusLabel(GETPAID_STATUS_LABEL[newLoanStatus])
  }

  Object.keys(pitch.pitchLines).forEach(key => {
    lineItems = [...lineItems, ...pitch.pitchLines[key]]
  })

  const putStatusMessage = status => {
    if (status === 0) return <span>Submitted</span>
    if (status === 1) return <span>Rejected</span>
    if (status === 2) return <span>Selected</span>
    if (status === 3) return <span>Withdrawn</span>
    if (status === 4) return <span>Draft</span>
    return <span>N/A</span>
  }

  return (
    <tr key={pitch.id}>
      <td>
        <SuperUserButton
          onClick={props.goesTopPlatform(
            props.data.profile.profileId,
            props.userEmail,
            `project/${props.data.id}/order?tab=pitch`,
            'project'
          )}
        />
      </td>
      <td width={150}>
        <Link to={`/profiles/${pitch.profile.profileId}`}>{pitch.profile.name}</Link>
      </td>
      <td
        width={200}
      >{`${pitch.order_detail.serviceName} ${pitch.order_detail.formatName}`}</td>
      <td>
        {lineItems.map((lineItem, index) => (
          <div key={lineItem.id}>{`${index + 1}. ${lineItem.description}`}</div>
        ))}
      </td>
      <td width={20}>{pitch.pitchLineQty}</td>
      <td width={150}>
        {lineItems.map(lineItem => (
          <div key={lineItem.id}>
            {lineItem.target ? (
              <NumberFormat
                thousandSeparator
                displayType="text"
                value={lineItem.target}
              />
            ) : (
              '-'
            )}
          </div>
        ))}
      </td>
      <td width={100}>
        {lineItems.map(lineItem => (
          <div key={lineItem.id}>
            {lineItem.cpx ? (
              <NumberFormat thousandSeparator displayType="text" value={lineItem.cpx} />
            ) : (
              '-'
            )}
          </div>
        ))}
      </td>
      <td width={200}>
        <NumberFormat
          thousandSeparator
          displayType="text"
          value={Math.round(
            (pitch.clientPrice ? pitch.clientPrice : pitch.subtotal) ||
              pitch.price * pitch.quantity
          )}
        />
      </td>
      <td width={150}>
        <NumberFormat
          thousandSeparator
          displayType="text"
          value={Math.round(props.calculate.filter(c => c.id === pitch.id)[0].finalPrice)}
        />
      </td>
      <td style={{ fontWeight: 'bold' }}>{putStatusMessage(pitch.status)}</td>
      <td width={100}>{pitch.user.email}</td>
      <td width={120}>{pitch.user.phone_number ? pitch.user.phone_number : '-'}</td>
      <td width={130}>
        <Link to={poCreatorURL} target="_blank">
          {poNumber}
        </Link>
      </td>
      <td width={150}>
        <Link to={`/projects/${props.data.id}/pitch/${pitch.id}`}>
          {`/projects/${props.data.id}/pitch/${pitch.id}`}
        </Link>
      </td>
      <td>
        <Link to={`${host}/${pitch.profile.profileId}/project/${pitch.order.id}`}>
          {`${host}/${pitch.profile.profileId}/project/${pitch.order.id}`}
        </Link>
      </td>
      <td>
        {isBankInfoExist ? (
          pitch.profileBankInformation[0].bank.name
        ) : (
          <span className="italic">No Bank Info Provided</span>
        )}
      </td>
      <td>
        {isBankInfoExist ? (
          pitch.profileBankInformation[0].accountNumber
        ) : (
          <span className="italic">No Bank Info Provided</span>
        )}
      </td>
      <td>
        {isBankInfoExist ? (
          pitch.profileBankInformation[0].accountName
        ) : (
          <span className="italic">No Bank Info Provided</span>
        )}
      </td>
      <td>
        <div dangerouslySetInnerHTML={{ __html: pitch.idea }} />
      </td>
      <td>
        {loanStatus === GETPAID_STATUS.IN_REVIEW && props.isProjectStarted ? (
          <div>
            <button
              className="btn btn-primary"
              onClick={props.putGetPaidStatus(
                pitch.loan?.id,
                GETPAID_STATUS.APPROVED,
                updateLoanStatus
              )}
            >
              Approve
            </button>
            <button
              className="btn btn-default"
              onClick={props.putGetPaidStatus(
                pitch.loan?.id,
                GETPAID_STATUS.REJECTED,
                updateLoanStatus
              )}
            >
              Reject
            </button>
          </div>
        ) : (
          <span>{loanStatusLabel}</span>
        )}
      </td>
    </tr>
  )
}

export default PitchRow
